export const MasterTitle = [
  { value: "Mr.", label: "Mr." },
  { value: "Mrs.", label: "Mrs." },
  { value: "Master", label: "Master" },
  { value: "Miss", label: "Miss" },
];

export const Role = [
  { value: "doctor", label: "Doctor" },
  { value: "receptionist", label: "Receptionist" },
];

export const paymentMethodOptions = [
  { value: "", label: "Select Method" },
  { value: "Cash", label: "Cash" },
  // { value: "Credit Card", label: "Credit Card" },
  { value: "UPI", label: "UPI" },
  // { value: "Net Banking", label: "Net Banking" },
];
export const StatusOptions = [
  { value: "", label: "Select Status" },
  { value: "valid", label: "Valid" },
  { value: "invalid", label: "Invalid" },
  { value: "all", label: "All" },

];
